import React from "react";

const ReserveringssystemenTable = ({ 
  reserveringssystemen, 
  onEdit, 
  onDelete, 
  onToggleActive 
}) => {
  const getSystemDisplayName = (naam) => {
    const displayNames = {
      tommy: "Tommy",
      boekingsexpert: "Boekingsexpert",
      recranet: "RecraNet",
      muws: "Muws",
      maxxton: "Maxxton"
    };
    return displayNames[naam] || naam || 'Naamloos systeem';
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Naam</th>
            <th>URL</th>
            <th>Authenticatie</th>
            <th>Headers</th>
            <th>Status</th>
            <th>Acties</th>
          </tr>
        </thead>
        <tbody>
          {reserveringssystemen.map((config) => (
            <tr key={config._id}>
              <td>
                <strong>{getSystemDisplayName(config.naam)}</strong>
              </td>
              <td>
                <code>{config.url}</code>
              </td>
              <td>
                <span className="badge bg-info">
                  {config.authMethod === 'none' ? 'Geen' : config.authMethod}
                </span>
              </td>
              <td>
                <span className="badge bg-secondary">
                  {config.headers ? config.headers.length : 0} headers
                </span>
              </td>
              <td>
                <span 
                  className={`badge ${config.actief ? 'bg-success' : 'bg-warning'}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => onToggleActive(config._id)}
                  title="Klik om status te wijzigen"
                >
                  {config.actief ? 'Actief' : 'Inactief'}
                </span>
              </td>
              <td>
                <div className="btn-group">
                  <button 
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => onEdit(config)}
                    title="Bewerken"
                  >
                    <i className="fa fa-edit"></i>
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => onDelete(config._id, getSystemDisplayName(config.naam))}
                    title="Verwijderen"
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReserveringssystemenTable;